import { initContract } from '@ts-rest/core';

const c = initContract();

export namespace BookingAuthApi {
    export type VerifyCodeResponse = {
        accessToken: string;
        clientId: number | null;
        clientName: string | null;
        phoneNumber: string;
    };

    export const contract = c.router(
        {
            requestCode: c.mutation({
                method: 'POST',
                path: '/auth/request-code',
                query: c.type<{ slug: string }>(),
                body: c.type<{ phoneNumber: string }>(),
                responses: {
                    204: c.noBody(),
                },
            }),
            verifyCode: c.mutation({
                method: 'POST',
                path: '/auth/verify-code',
                query: c.type<{ slug: string }>(),
                body: c.type<{ phoneNumber: string; code: string }>(),
                responses: {
                    200: c.type<VerifyCodeResponse>(),
                },
            }),
            refresh: c.mutation({
                method: 'POST',
                path: '/auth/refresh',
                query: c.type<{ slug: string }>(),
                body: c.noBody(),
                responses: {
                    200: c.type<{ accessToken: string }>(),
                },
            }),
            logout: c.mutation({
                method: 'POST',
                path: '/auth/logout',
                body: c.noBody(),
                responses: {
                    204: c.noBody(),
                },
            }),
        },
        { strictStatusCodes: true },
    );
}
